import { Injectable } from '@angular/core';
import { Paginator } from '../models/paginator';
import { Project } from '../models/project';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class ProjectListService {
  private sorting: { by: string; reverse: boolean };
  private filters: { [p: string]: any[] };
  private searchString: string;
  private clientIds: number[];

  constructor(private http: HttpClient) {
  }

  fetch(page: number, size?: number): Promise<Paginator<Project>> {
    console.log(this.sorting, this.filters, page);

    let params = new HttpParams();
    if (this.filters) {
      Object.keys(this.filters).forEach(k => {
        params = params.append(k, <string>this.filters[k].join(','));
      })
    }

    if (this.filters.client) {
      params = params.set('client', '' + this.filters.client);
    }

    if (this.filters.statuses && this.filters.statuses.length) {
      params = params.set('status', this.filters.statuses.join(','));
    }

    if (this.sorting) {
      params = params.set('sort', this.sorting.by);
      if (!this.sorting.reverse) {
        params = params.set('sortOrder', 'asc');
      }
    }

    if (this.searchString) {
      params = params.set('q', this.searchString);
    }

    if (this.clientIds.length) {
      params = params.set('client', '' + this.clientIds[0]);
    }

    params = params.append('page', page.toString());

    return this.http.get<any>(`${environment.apiUrl}/projects`, { params: params })
      .pipe(map(json => {
        let projects = json.data.map(row => {
          return new Project(row);
        });
        return new Paginator<Project>(json.meta.pagination, projects);
      })).toPromise();
  }

  filter(filters: { [p: string]: any[] }) {
    this.filters = filters;
    return this;
  }

  sort(sort: { by: string; reverse: boolean }) {
    this.sorting = sort;
    return this;
  }

  search(str: string) {
    this.searchString = str;
    return this;
  }

  clients(clients: number[]) {
    this.clientIds = clients;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/project-list.service.ts